import { faArrowPointer, faBolt, faCircleX, faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../styles/componentStyles/ColumnGrid.css';

import React from 'react';
import { useTranslation } from 'react-i18next';

function ColumnGridEmpty(props) {
  const { t } = useTranslation();

  return (
    <div className={`chart-container ${props.width}`}>
      <div className="title-container">
        <h3 className="title">{props.title}</h3>
      </div>
      <div className="grid-container">
        <div className="column fs-exclude">
          <div className="row">
            <div className="row-heading empty">{t('D015')}</div>
            <div className="empty">{t('chart.noDataAvailable')}</div>
          </div>

          <div className="row msk-row-empty">
            <div className="row-heading empty ">{t('D016')}</div>
            <div className="empty">
              <span className="icon_circle">
                <FontAwesomeIcon icon={faArrowPointer} className="icon" />
              </span>
              --
            </div>
          </div>

          <div className="row msk-row-empty">
            <div className="row-heading empty">{t('D017')}</div>
            <div className="empty">
              <span className="icon_circle">
                <FontAwesomeIcon icon={faBolt} className="icon" />
              </span>
              --
            </div>
          </div>
          <div className="row msk-row-empty">
            <div className="row-heading empty">{t('D018')}</div>
            <div className="empty">
              <span className="icon_circle ">
                <FontAwesomeIcon icon={faCircleX} className="icon" />
              </span>
              --
            </div>
          </div>

          <div className="row msk-row-empty">
            <div className="row-heading empty">{t('D019')}</div>
            <div className="empty">
              <span className="icon_circle">
                <FontAwesomeIcon icon={faShieldCheck} className="icon" />
              </span>
              --
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ColumnGridEmpty;
